import React from 'react';
import { useSelector } from 'react-redux';

const Header = () => {
  const { totalCount } = useSelector((state) => state.adminPanelAgencies);
  return (
    <div className="adminPanel__header">
      <h5>
        List Of Agencies: <strong>{totalCount}</strong>
      </h5>
    </div>
  );
};

export default Header;
